import * as React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepButton from "@mui/material/StepButton";
import Button from "@mui/material/Button";
import { useDispatch, useSelector } from "react-redux";
import {
  setAddFields,
  setCombinationUpsaleData,
  setCombinationUpsaleProductsQTY,
  setExtraFieldsData,
  setGuestDetailsData,
  setGuestFields,
  setIsBackToHoreca,
  setQuantities,
  setSelectedCombinationExtraProduct,
  setSelectedExtraProduct,
  setTotalPriceInclusiveVAT,
  setTotalVAT,
  setTransactionDetails,
} from "../../store/slice/Ticketing.slice";
import {
  CircularProgress,
  StepConnector,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import ConfirmandPay from "./ConfirmandPay";
import { useNavigate } from "react-router-dom";
import CreditScoreIcon from "@mui/icons-material/CreditScore";
import ArrowForwardIosTwoToneIcon from "@mui/icons-material/ArrowForwardIosTwoTone";
import ArrowBackIosTwoToneIcon from "@mui/icons-material/ArrowBackIosTwoTone";
import {
  getExtraFieldDetails,
  getGuestDetails,
  transactionCostForReservation,
} from "../../api/HorecaWidget.service";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import customParseFormat from "dayjs/plugin/customParseFormat";
import Snackbar from "@mui/material/Snackbar";
import dayjs from "dayjs";
import { CreateTicketingReservation } from "../../api/ticketing.service";
import { format_Number } from "../../utils/utils";
import Combination from "../Component/Combination";
import UpsaleProduct from "../Component/UpsaleProduct";
import UserDetailsSection from "../Component/UserDetailSection";
import InactivityPopup from "../../utils/InActivityPopup";
import UpsaleProductCombination from "../Component/UpsaleProductCombination";
dayjs?.extend(customParseFormat);

const DottedStepConnector = (props) => (
  <StepConnector
    {...props}
    sx={{
      "& .MuiStepConnector-line": {
        borderColor: "#000000", 
        borderStyle: "dashed",
        borderWidth: 1,
      },
    }}
  />
);

export default function BookNowForm() {
  const stepContentRef = React.useRef(null);
  const { combinationList, combinationQTY, selectedCombination } = useSelector(
    (store) => store.Activity
  );
  const {
    css
  }=useSelector((store)=> store?.widgetSettings);
  const bookBtnCss = css?.find(
    (item) => item?.cssTabFieldsGroupName === "Overall"
  )?.fields
  const {
    reservType,
    GuestDetailsData,
    extraProductData,
    quantities,
    selectedDate,
    time,
    totalCount,
    selectedExtraProduct,
    transactionDetails,
    guestFields,
    addFields,
    languageWords,
    defaultLanguage,
    extraFieldsData,
    SelectedEventOrStdResType,
    TotalPrice,
    TotalPriceInclusiveVATs,
    TotalVAT,
    guestCounts,
    combinationUpsaleData,
    selectedCombinationUpsale,
    combinationUpsaleProductsQTY,
  } = useSelector((store) => store.Ticketing);
  
  const { languageData, deviceId } = useSelector(
    (store) => store?.widgetSettings
  );
  const { defaultLang } = useSelector((store) => store?.Combination);
  const [steps, setSteps] = React.useState([
    languageWords?.Availability,
    languageWords?.ExtraProducts,
    languageWords?.combinations,
    languageWords?.yourDetails,
    languageWords?.ConfirmandPay,
  ]);

  const [isLoading, setIsLoading] = React.useState(false);
  const theme = useTheme();
  const { WidgetSetting, key, floating, widgetConfig } = useSelector(
    (store) => store?.widgetSettings
  );
  const reservationRequestMin =
    parseInt(
      WidgetSetting?.find((item) => item?.tag === "reservationRequest")
    ) ?? 0;
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = React.useState(1);
  const [completed, setCompleted] = React.useState({ 0: false });
  const { isBookNowOpen } = useSelector((store) => store.addGuest);
  const dispatch = useDispatch();
  const totalSteps = () => steps.length;
  const [state, setState] = React.useState({
    open: false,
    vertical: "top",
    horizontal: "right",
  });
  const { vertical, horizontal, open } = state;
  const handleClosebar = () => {
    setState({ ...state, open: true });

    setTimeout(() => {
      setState({ ...state, open: false });
    }, 5000);
  };
  const completedSteps = () => Object.keys(completed).length;
  const isLastStep = () => activeStep === totalSteps() - 1;
  const allStepsCompleted = () => completedSteps() === totalSteps();
  const handleNext = () => {
    const newActiveStep =
      isLastStep() && !allStepsCompleted()
        ? steps.findIndex((step, i) => !(i in completed))
        : activeStep + 1;
    setActiveStep(newActiveStep);
  };
  const handleBack = () => {
    if (activeStep == 1) {
      dispatch(setIsBackToHoreca(true));
      navigate(-1);
      return;
    }
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
    setCompleted({});
  };

  const VAT_PERCENT_PRODUCTS = SelectedEventOrStdResType?.vat;
  const VAT_TOTAL_PRODUCTS =
    TotalPrice - TotalPrice / (1 + VAT_PERCENT_PRODUCTS / 100);
  const VAT_TOTAL_EXTRA = selectedExtraProduct?.reduce((acc, product) => {
    return (
      (acc + (product?.price - product?.price / (1 + product?.vat / 100))) *
      product.quantity
    );
  }, 0);
  const VAT_TOTAL_TRANSACTION_COST =
    (transactionDetails?.pricePerReservation -
      transactionDetails?.pricePerReservation /
        (1 + transactionDetails?.vat / 100)) *
      1 || 0;

  const VAT_TOTAL_COMBINATIONS = selectedCombination?.reduce((acc, product) => {
    return (
      (acc + (product?.price - product?.price / (1 + product?.vat / 100))) *
      combinationQTY[product?.idreservationtype + String(product.isBefore)]
    );
  }, 0);
  const VAT_TOTAL_COMBINATIONS_UPSALE =
    selectedCombinationUpsale?.reduce((acc, product) => {
      return (
        (acc + (product?.price - product?.price / (1 + product?.vat / 100))) *
        product?.quantity
      );
    }, 0) || 0;
  const TOTAL_VAT = (
    VAT_TOTAL_PRODUCTS +
    VAT_TOTAL_EXTRA +
    VAT_TOTAL_TRANSACTION_COST +
    VAT_TOTAL_COMBINATIONS +
    VAT_TOTAL_COMBINATIONS_UPSALE
  ).toFixed(2);
  const totalSum = selectedExtraProduct?.reduce((acc, product) => {
    return acc + product.quantity * product.price;
  }, 0);
  const totalUpsaleCombinationPrice =
    selectedCombinationUpsale?.reduce(
      (acc, product) =>
        acc + product?.price * combinationUpsaleProductsQTY[product?.idproduct],
      0
    ) || 0;
  const totalCombination = selectedCombination?.reduce(
    (acc, product) =>
      (acc + product?.price) *
      combinationQTY[product?.idreservationtype + String(product.isBefore)],
    0
  );
  const TOTAL_INCLUSIVE_VAT =
    TotalPrice +
    totalSum +
    transactionDetails?.pricePerReservation +
    totalCombination +
    totalUpsaleCombinationPrice;

  React.useEffect(() => {
    dispatch(setTotalVAT(TOTAL_VAT));
    dispatch(setTotalPriceInclusiveVAT(TOTAL_INCLUSIVE_VAT));
  }, [TOTAL_INCLUSIVE_VAT, TOTAL_VAT]);

  const TOTAL_PRODUCT_PRICE =
    TotalPrice + totalSum + totalCombination + totalUpsaleCombinationPrice;

  const fetchGuestDetails = async () => {
    try {
      const response = await getGuestDetails(
        key,
        SelectedEventOrStdResType?.idreservationtype,
        defaultLang ? defaultLang : defaultLanguage
      );
      if (response?.status != 200 || !response?.data) {
        console.error("Failed to fetch guest details:", response);
        return;
      }
      dispatch(setGuestDetailsData(response?.data));
    } catch (error) {
      console.error(error);
    }
  };

  const fetchExtraFieldDetails = async () => {
    try {
      const response = await getExtraFieldDetails(
        SelectedEventOrStdResType?.idreservationtype,
        defaultLang ? defaultLang : defaultLanguage,
        key
      );
      dispatch(setExtraFieldsData(response));
    } catch (error) {
      console.error(error);
    }
  };

  const creatBookingReservation = async () => {
    setIsLoading(true);
    const guestPayload = guestFields.reduce((acc, item) => {
      const key = item.idfield.replace(/{|}/g, "");
      acc[key] = item.data;
      return acc;
    }, {});
    const combinationInfoPayload =
 
         selectedCombination?.map((item) => {
            let count =
              combinationQTY[item?.idreservationtype + String(item.isBefore)];
            const combinationUpsalePrice =
              selectedCombinationUpsale?.reduce((acc, item) => {
                return acc + item.quantity * item.price;
              }, 0) || 0;
            const selectedTables = (() => {
              if (!item?.tables) return [];
              if (item?.activitiesPriceType === "pricepertime") {
                return item.tables?.slice(0, count);
              } else {
                const singleTable = item?.tables?.find(
                  (table) => table.seats >= count
                );
                if (singleTable) {
                  return [singleTable];
                } else {
                  let seatSum = 0;
                  let tablesPicked = [];
                  for (let table of item?.tables) {
                    tablesPicked?.push(table);
                    seatSum += table.seats;
                    if (seatSum >= count) break;
                  }
                  return tablesPicked;
                }
              }
            })();

            return {
              combinationUpsaleProduct: selectedCombinationUpsale?.filter(
                (prod) =>
                  prod?.isBefore == item?.isBefore &&
                  prod.idreservationtype == item.idreservationtype
              ),
              idreservationtype: item?.idreservationtype,
              EventTicketDateTimeId:
                item?.eventTicketDateTimeId == 0
                  ? null
                  : item?.eventTicketDateTimeId,
              ArrivalDate: reservType?.isStandardTicket
                ? selectedDate
                : selectedDate?.availableDate,
              DepartureDate: reservType?.isStandardTicket
                ? selectedDate
                : selectedDate?.availableDate,
              ArrivalTime: item?.arrivalTime,
              DepartureTime: item?.depatureTime,
              vat: item?.vat,
              VATAmount: Number(
                parseFloat(
                  VAT_TOTAL_COMBINATIONS + VAT_TOTAL_COMBINATIONS_UPSALE
                ).toFixed(2)
              ),
              PaymentAmount: count * item?.price + combinationUpsalePrice,
              ReservationLocations: selectedTables.map((table) => ({
                idtables: table?.idtables,
                ArrivalDate: reservType?.isStandardTicket
                  ? selectedDate
                  : selectedDate?.availableDate,
                DepartureDate: reservType?.isStandardTicket
                  ? selectedDate
                  : selectedDate?.availableDate,
                ArrivalTime: item?.arrivalTime,
                DepartureTime: item?.depatureTime,
                seats: table?.seats,
              })),
              MainModuleId: item?.mainModuleId,
              Guests: [guestPayload],
              numberOfGuest:
                item?.activitiesPriceType == "pricepertime"
                  ? totalCount
                  : combinationQTY[
                      item?.idreservationtype + String(item.isBefore)
                    ],
              LanguageCode: defaultLanguage,
            };
          })




    const payload = {
      KioskDeviceId: deviceId,
      WidgetId:Number(widgetConfig?.settings?.idwidgetsetup),
      SumOfPaymentAmount: Number(parseFloat(TOTAL_INCLUSIVE_VAT).toFixed(2)),
      Key: key,
      kioskMode: widgetConfig?.settings?.kioskMode,
      TicketingReservation: {
        EventTicketDateTimeId: selectedDate?.eventTicketDateTimeId ?? null,
        TicketingReservationId: 0,
        TicketId: parseInt(reservType?.eventTicketId),
        IsStandardTicket: reservType?.isStandardTicket,
        TicketDate: reservType?.isStandardTicket
          ? selectedDate
          : selectedDate?.availableDate,
        idreservationtype: SelectedEventOrStdResType?.idreservationtype,
        NoCustomerInfoRequired: false,
        idlanguage: languageData?.find(
          (item) =>
            item?.langcode.toLowerCase() == defaultLanguage.toLowerCase()
        
      )?.idlanguage,
        EventTicketQty: reservType?.isStandardTicket ? 0 : totalCount,
        Field1: reservType?.isStandardTicket
          ? guestCounts[SelectedEventOrStdResType?.idreservationtype]?.adult
          : 0,
        Field2: reservType?.isStandardTicket
          ? guestCounts[SelectedEventOrStdResType?.idreservationtype]?.child
          : 0,
        Field3: reservType?.isStandardTicket
          ? guestCounts[SelectedEventOrStdResType?.idreservationtype]?.kid
          : 0,
        Field4: reservType?.isStandardTicket
          ? guestCounts[SelectedEventOrStdResType?.idreservationtype]?.baby
          : 0,
        Field5: reservType?.isStandardTicket
          ? guestCounts[SelectedEventOrStdResType?.idreservationtype]?.toddler
          : 0,
        idstatussetup: 0,
        IsCancelled: false,
        IsPaymentDone: false,
        TicketingUpsaleProducts: [],
        NameOnReservation: "widget",
        PaymentAmount: TotalPrice + totalSum,
        VATAmount: Number(
          parseFloat(
            VAT_TOTAL_PRODUCTS + VAT_TOTAL_EXTRA + VAT_TOTAL_TRANSACTION_COST
          )
        ),
        AdoptedBy: "widget",
        NoCustomerInfoRequired: false,
        IsEmailRequired: false,
        TicketingUpsaleProducts: selectedExtraProduct?.map((item) => ({
          UpsaleProductId: item?.idproduct,
          ProductPrice: item?.price,
          Qty: item?.quantity,
        })),
        TicketingTransactionCosts: [
          {
            TransactionProductId: transactionDetails?.idproduct,
            Price: transactionDetails?.pricePerReservation,
          },
        ],
        TicketingEventProducts: !reservType?.isStandardTicket
          ? [
              {
                EventProductId: parseInt(SelectedEventOrStdResType?.productId),
                ProductPrice: parseInt(
                  SelectedEventOrStdResType?.eventProductPrice
                ),
              },
            ]
          : [],
        TicketingGuestFields: [...guestFields] || [],
        TicketingReservationFields: addFields,
        TicketingDayPriceProducts: reservType?.isStandardTicket
          ? [
              {
                EventProductId: parseInt(SelectedEventOrStdResType?.productId),
                Price1: SelectedEventOrStdResType?.dayProductPrice1,
                Price2: SelectedEventOrStdResType?.dayProductPrice2,
                Price3: SelectedEventOrStdResType?.dayProductPrice3,
                Price4: SelectedEventOrStdResType?.dayProductPrice4,
                Price5: SelectedEventOrStdResType?.dayProductPrice5,
                TicketingReservation: {},
              },
            ]
          : [],
        PayCash: false,
        PayTerminal: true,
        PayOther: false,
        CombinationInfo: combinationInfoPayload,
      },
    };

    try {
      const response = await CreateTicketingReservation(payload);

      if (response?.status == "open") {
        const checkoutUrl = `${response?._links?.checkout?.href}`;
        if (widgetConfig?.settings?.kioskMode || deviceId) {
          window.location.href = checkoutUrl;
        } else {
          if (window.parent && window.parent !== window) {
            window.parent.postMessage({ redirectUrl: checkoutUrl }, "*");
          } else {
            window.location.href = checkoutUrl;
          }
        }

      } 
      else {
        console.error("Failed to create booking reservation:", response);
        handleClosebar();
      }
      setIsLoading(false);
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };

  const fetchTransactionDetails = async () => {
    try {
      const response = await transactionCostForReservation(
        key,
        SelectedEventOrStdResType?.idreservationtype,
        defaultLang ? defaultLang : defaultLanguage
      );
      if (response?.status != 200 || !response?.data) {
        console.info("transaction details not found");
      }
      dispatch(setTransactionDetails(response?.data));
    } catch (error) {
      console.log("error in transaction cost:", error?.message);
      throw new Error(error?.message);
    }
  };

  const createInitialValuesAndValidationSchema = (
    guestData,
    extraData,
    widgetConfig
  ) => {
    const initialValues = {};
    const validationShape = {};

    const processFieldData = (
      field,
      languageType,
      customLink,
      shouldApplyValidation
    ) => {
      let languageData = field[languageType]?.find(
        (f) => f?.fieldname == "name"
      )?.data;

      if (customLink) {
        languageData = "Link";
      } else if (field?.type == "textarea") {
        if (typeof field[languageType]?.[0]?.data === "string") {
          languageData = field[languageType]
            ?.find((f) => f?.fieldname == "name")
            ?.data?.replace(".", "");
        } else {
          languageData = field[languageType]?.find(
            (f) => f?.fieldname == "name"
          )?.data;
        }
      }

      if (!languageData) return; 

      if (field?.type == "checkboxList") {
        initialValues[languageData] = [];
      } else {
        initialValues[languageData] = "";
      }

      let validationRule;

      if (field?.type === "label" || field?.type === "link") {
        validationRule = Yup.mixed().notRequired(); 
      } else if (field.tag === "{email}") {
        validationRule = Yup.string().email("Invalid email format");
      } else if (field.tag === "{phone}") {
        validationRule = Yup.string().matches(
          /^\+?\d{1,3}\s*\(?\d{1,4}?\)?[\s.-]?\d{1,4}[\s.-]?\d{1,4}[\s.-]?\d{1,9}$/,
          "Invalid phone number format"
        );
      } else if (field?.type === "termsandcondition") {
        validationRule = Yup.boolean().oneOf(
          [true],
          "You must accept the terms and conditions"
        );
      } else if (field?.type == "checkboxList") {
        validationRule = Yup.array().of(Yup.string());
      } else {
        validationRule = Yup.string();
      }
      if (
        shouldApplyValidation &&
        field.required &&
        field?.type !== "label" &&
        field?.type !== "link"
      ) {
        validationRule = validationRule.required("Required");
      }
      validationShape[languageData] = validationRule;
    };

    guestData?.forEach((field) =>
      processFieldData(
        field,
        "guestLanguages",
        field.type == "link",
        !widgetConfig?.token
      )
    );

    extraData?.forEach(
      (field) =>
        processFieldData(field, "fieldsLanguages", field.type == "link", true) 
    );

    return {
      initialValues,
      validationSchema: Yup.object().shape(validationShape),
    };
  };

  const { initialValues, validationSchema } =
    createInitialValuesAndValidationSchema(
      GuestDetailsData,
      extraFieldsData,
      widgetConfig
    );

  React.useEffect(() => {
    fetchGuestDetails();
    fetchTransactionDetails();
    fetchExtraFieldDetails();
  }, []);

  
  const send = (
    frameHeight,
    frameWidth,
    top,
    right,
    bottom,
    left,
    floating,
    redirectUrl
  ) => {
    window.parent.postMessage(
      {
        reservationIframeHeight: frameHeight,
        reservationIframeWidth: frameWidth,
        reservationIframePositionTop: top,
        reservationIframePositionRight: right,
        reservationIframePositionBottom: bottom,
        reservationIframePositionLeft: left,
        reservationIframePositionFloating: floating,
        redirectUrl: redirectUrl,
      },
      "*"
    );
  };

  React.useEffect(() => {
    if (extraProductData?.length == 0 && combinationList.length == 0) {
      setSteps([
        languageWords?.Availability,
        languageWords?.yourDetails,
        languageWords?.ConfirmandPay,
      ]);
    } else if (extraProductData?.length == 0 && combinationList.length > 0) {
      setSteps([
        languageWords?.Availability,
        languageWords?.combinations,
        languageWords?.yourDetails,
        languageWords?.ConfirmandPay,
      ]);
    }
  }, [extraProductData]);

  React.useEffect(() => {
    document.body.setAttribute(
      "style",
      "background-color: " + theme?.widget?.stepScreenBgColor + " !important"
    ); 
    if (combinationList.length == 0 && extraProductData?.length == 0) {
      setSteps([
        languageWords?.Availability,
        languageWords?.yourDetails,
        languageWords?.ConfirmandPay,
      ]);
    } else if (combinationList.length == 0 && extraProductData?.length != 0) {
      setSteps([
        languageWords?.Availability,
        languageWords?.ExtraProducts,
        languageWords?.yourDetails,
        languageWords?.ConfirmandPay,
      ]);
    }
  }, [combinationList]);

  React.useEffect(() => {
    if (totalCount >= widgetConfig?.reservationRequestMin) {
      setSteps([
        languageWords?.Availability,
        languageWords?.yourDetails,
        languageWords?.ConfirmandPay,
      ]);
    }
  }, [totalCount]);
  React.useEffect(() => {
    if (
      combinationList?.length > 0 &&
      combinationUpsaleData?.length != 0 &&
      extraProductData?.length != 0
    ) {
      setSteps([
        languageWords?.Availability,
        languageWords?.ExtraProducts,
        languageWords?.combinations,
        languageWords?.combination_extraproduct || "Combination Extra Product",
        languageWords?.yourDetails,
        languageWords?.ConfirmandPay,
      ]);
    } else if (
      combinationList?.length > 0 &&
      combinationUpsaleData?.length > 0 &&
      extraProductData?.length == 0
    ) {
      setSteps([
        languageWords?.Availability,
        languageWords?.combinations,
        languageWords?.combination_extraproduct || "Combination Extra Product",
        languageWords?.yourDetails,
        languageWords?.ConfirmandPay,
      ]);
    }
     else if (
      combinationList?.length > 0 &&
      selectedCombination?.length == 0 &&
      extraProductData?.length != 0
    ) {
      setSteps([
        languageWords?.Availability,
        languageWords?.ExtraProducts,
        languageWords?.combinations,
        languageWords?.yourDetails,
        languageWords?.ConfirmandPay,
      ]);
    } else if (
      combinationList?.length > 0 &&
      selectedCombination?.length == 0 &&
      extraProductData?.length == 0
    ) {
      setSteps([
        languageWords?.Availability,
        languageWords?.combinations,
        languageWords?.yourDetails,
        languageWords?.ConfirmandPay,
      ]);
    }
  }, [selectedCombination, combinationUpsaleData]);

  const updateWidgetHeight = () => {
    if (!stepContentRef.current) return;
  
    const contentHeight = Math.ceil(stepContentRef.current.scrollHeight);
  
    send(
      `${contentHeight}px`, 
      "100%",             
      "", "", "", "",        
      widgetConfig?.settings?.floatButtonActive
    );
  };
  const scrollToTop = () => {
    setTimeout(() => {
      // Try all possible scroll targets
      window.scrollTo({ top: 0, behavior: "smooth" });
      document.documentElement.scrollTo({ top: 0, behavior: "smooth" });
      document.body.scrollTo({ top: 0, behavior: "smooth" });
      
      if (stepContentRef.current) {
        stepContentRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
      }
  
      updateWidgetHeight();
    }, 100);
  };
  
  React.useLayoutEffect(() => {
    updateWidgetHeight();
    scrollToTop();
  }, [activeStep, steps]);
const handleNextFunc=(errors)=>{
  if (
    steps[activeStep] === languageWords?.yourDetails
  ) {
    if (Object.keys(errors).length == 0) {
      creatBookingReservation();
    }
  } else {
    handleNext();
  }
}

React.useEffect(() => {
  if (!stepContentRef.current) return;

  const observer = new ResizeObserver(() => {
    updateWidgetHeight();
  });

  observer.observe(stepContentRef.current);

  return () => observer.disconnect();
}, []);
  return (
    <>
      {deviceId && <InactivityPopup languageWords={languageWords} />}
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values, { setSubmitting }) => {

        }}
      >
        {({
          values,
          handleChange,
          handleSubmit,
          touched,
          errors,
          dirty,
          setFieldTouched,
          setFieldValue,
        }) => (
          <Box
          ref={stepContentRef}
            sx={{
              backgroundColor: theme?.widget?.stepScreenBgColor,
       
              p: 1,
            }}
          >
            <Box
              sx={{
                backgroundColor: theme?.widget?.stepScreenBgColor,
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  overflow: "hidden", 
                  px: 2,
                  mb: 5,
                }}
              >
                <Stepper
                  nonLinear
                  activeStep={activeStep}
                  connector={<DottedStepConnector />}
                  sx={{
                    mt: 1,
                    flexWrap: { xs: "wrap", sm: "nowrap" },
                    justifyContent: { xs: "center", sm: "flex-start" },
                  }}
                >
                  {steps.map((label, index) => (
                    <Step key={label} completed={completed[index]}>
                      <StepButton
                                              sx={{
                                                ...(activeStep === index && {
                                                  "& .MuiStepLabel-label": {
                                                    color:
                                                      activeStep === index
                                                        ? bookBtnCss?.stepTextColorActive
                                                        :bookBtnCss?.stepTextColor,
                                                    fontWeight: "bold",
                                                    fontSize: "15px",
                                                 
                                                  },
                                                  "& .MuiStepIcon-root": {
                                                    color:
                                                      activeStep === index
                                                        ? bookBtnCss?.stepCircleActiveBg
                                                         : bookBtnCss?.stepBtnDisabledBg
                                                        ,
                                                    borderRadius: "50%",
                      
                                                    "& .MuiStepIcon-text": {
                                                      fill:
                                                        activeStep === index
                                                          ? bookBtnCss?.stepCircleTextActive
                                                          : bookBtnCss?.stepBtnText,
                                                    },
                                                  },
                                                }),
                                                width: { xs: "100%", sm: "auto" },
                                                fontSize: { xs: "12px", sm: "inherit" },
                                              }}

                        disabled={true}
                      >
                        {isSmallScreen ? "" : label}
                      </StepButton>
                    </Step>
                  ))}
                </Stepper>
              </Box>
              <div>
                {allStepsCompleted() ? (
                  <React.Fragment>
                 
                    <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                      <Box sx={{ flex: "1 1 auto" }} />
                      <Button onClick={handleReset}>Reset</Button>
                    </Box>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <Box>
                      {(() => {
                        switch (steps[activeStep]) {
                          case languageWords?.Availability:
                            navigate(-1, {
                              state: { openWidgetScreen: true },
                            });
                            break;

                          case languageWords?.ExtraProducts:
                            return (
                              <UpsaleProduct
                              steps={steps}
                              activeStep={activeStep}
                              handleBack={handleBack}
                              handleNextFunc={handleNextFunc}
                              errors={errors}
                              price={TOTAL_INCLUSIVE_VAT}     
                              isLoading={isLoading}
                                selectedExtraProduct={selectedExtraProduct}
                                extraProductData={extraProductData}
                                quantities={quantities}
                                selectedCombination={selectedCombination}
                                totalCount={totalCount}
                                languageWords={languageWords}
                                reservType={{
                                  ...SelectedEventOrStdResType,
                                  ...reservType,
                                }}
                                selectedDate={selectedDate}
                                adult={
                                  guestCounts[
                                    SelectedEventOrStdResType?.idreservationtype
                                  ]?.adult
                                }
                                child={
                                  guestCounts[
                                    SelectedEventOrStdResType?.idreservationtype
                                  ]?.child
                                }
                                kid={
                                  guestCounts[
                                    SelectedEventOrStdResType?.idreservationtype
                                  ]?.kid
                                }
                                baby={
                                  guestCounts[
                                    SelectedEventOrStdResType?.idreservationtype
                                  ]?.baby
                                }
                                toddler={
                                  guestCounts[
                                    SelectedEventOrStdResType?.idreservationtype
                                  ]?.toddler
                                }
                                time={time}
                                transactionDetails={transactionDetails}
                                transactionPrice={
                                  transactionDetails?.pricePerReservation
                                }
                                excludingVat={
                                  TOTAL_INCLUSIVE_VAT -
                                  TOTAL_VAT -
                                  transactionDetails?.pricePerReservation
                                }
                                totalVat={TOTAL_VAT}
                                totalIncludingVAT={TOTAL_INCLUSIVE_VAT}
                                totalCostYourBooking={TotalPrice + totalSum}
                                setQuantities={setQuantities}
                                setSelectedExtraProduct={
                                  setSelectedExtraProduct
                                }
                                combinationUpsale={selectedCombinationUpsale}
                                setCombinationUpsale={
                                  setSelectedCombinationExtraProduct
                                }
                                total_product_price={TOTAL_PRODUCT_PRICE}
                              />
                            );

                          case languageWords?.combinations:
                            return (
                              <Combination
                              steps={steps}
                              activeStep={activeStep}
                              handleBack={handleBack}
                              errors={errors}
                              handleNextFunc={handleNextFunc}
                              price={TOTAL_INCLUSIVE_VAT}     
                              isLoading={isLoading}
                                selectedCombination={selectedCombination}
                                totalCount={totalCount}
                                languageWords={languageWords}
                                reservType={{
                                  ...SelectedEventOrStdResType,
                                  ...reservType,
                                }}
                                selectedDate={selectedDate}
                                time={time}
                                adult={
                                  guestCounts[
                                    SelectedEventOrStdResType?.idreservationtype
                                  ]?.adult
                                }
                                child={
                                  guestCounts[
                                    SelectedEventOrStdResType?.idreservationtype
                                  ]?.child
                                }
                                kid={
                                  guestCounts[
                                    SelectedEventOrStdResType?.idreservationtype
                                  ]?.kid
                                }
                                baby={
                                  guestCounts[
                                    SelectedEventOrStdResType?.idreservationtype
                                  ]?.baby
                                }
                                toddler={
                                  guestCounts[
                                    SelectedEventOrStdResType?.idreservationtype
                                  ]?.toddler
                                }
                                selectedExtraProduct={selectedExtraProduct}
                                transactionDetails={transactionDetails}
                                transactionPrice={
                                  transactionDetails?.pricePerReservation
                                }
                                excludingVat={
                                  TOTAL_INCLUSIVE_VAT -
                                  TOTAL_VAT -
                                  transactionDetails?.pricePerReservation
                                }
                                totalVat={TOTAL_VAT}
                                totalIncludingVAT={TOTAL_INCLUSIVE_VAT}
                                totalCostYourBooking={TotalPrice + totalSum}
                                setUpsaleCombination={setCombinationUpsaleData}
                                combinationUpsale={selectedCombinationUpsale}
                                setCombinationUpsale={
                                  setSelectedCombinationExtraProduct
                                }
                                total_product_price={TOTAL_PRODUCT_PRICE}
                              />
                            );

                          case languageWords?.combinationUpsaleProduct ||
                            "Combination Extra Product":
                            return (
                              <UpsaleProductCombination
                              steps={steps}
                              activeStep={activeStep}
                              handleBack={handleBack}
                              handleNextFunc={handleNextFunc}
                              errors={errors}
                              price={TOTAL_INCLUSIVE_VAT}     
                              isLoading={isLoading}
                                selectedExtraProduct={selectedExtraProduct}
                                extraProductData={extraProductData}
                                selectedCombination={selectedCombination}
                                totalCount={totalCount}
                                languageWords={languageWords}
                                reservType={{
                                  ...SelectedEventOrStdResType,
                                  ...reservType,
                                }}
                                selectedDate={selectedDate}
                                adult={
                                  guestCounts[
                                    SelectedEventOrStdResType?.idreservationtype
                                  ]?.adult
                                }
                                child={
                                  guestCounts[
                                    SelectedEventOrStdResType?.idreservationtype
                                  ]?.child
                                }
                                kid={
                                  guestCounts[
                                    SelectedEventOrStdResType?.idreservationtype
                                  ]?.kid
                                }
                                baby={
                                  guestCounts[
                                    SelectedEventOrStdResType?.idreservationtype
                                  ]?.baby
                                }
                                toddler={
                                  guestCounts[
                                    SelectedEventOrStdResType?.idreservationtype
                                  ]?.toddler
                                }
                                time={time}
                                transactionDetails={transactionDetails}
                                transactionPrice={
                                  transactionDetails?.pricePerReservation
                                }
                                excludingVat={
                                  TOTAL_INCLUSIVE_VAT -
                                  TOTAL_VAT -
                                  transactionDetails?.pricePerReservation
                                }
                                totalVat={TOTAL_VAT}
                                totalIncludingVAT={TOTAL_INCLUSIVE_VAT}
                                totalCostYourBooking={TotalPrice + totalSum}
                                setSelectedExtraProduct={
                                  setSelectedCombinationExtraProduct
                                }
                                selectedUpsaleCombination={
                                  selectedCombinationUpsale
                                }
                                qty={combinationUpsaleProductsQTY}
                                setQty={setCombinationUpsaleProductsQTY}
                                UpsaleCombinationData={combinationUpsaleData}
                                combinationUpsale={selectedCombinationUpsale}
                                setCombinationUpsale={
                                  setSelectedCombinationExtraProduct
                                }
                                total_product_price={TOTAL_PRODUCT_PRICE}
                              />
                            );

                          case languageWords?.yourDetails:
                            return (
                              <UserDetailsSection
                              steps={steps}
                              errors={errors}
                              activeStep={activeStep}
                              handleBack={handleBack}
                              handleNextFunc={handleNextFunc}
                              price={TOTAL_INCLUSIVE_VAT}     
                              isLoading={isLoading}
                              selectedCombination={selectedCombination}
                              defaultLanguage={defaultLanguage}
                                values={values}
                                setField={setFieldValue} 
                                touched={touched}
                                totalCount={totalCount}
                                languageWords={languageWords}
                                reservType={{
                                  ...SelectedEventOrStdResType,
                                  ...reservType,
                                }}
                                selectedDate={selectedDate}
                                time={time}
                                adult={
                                  guestCounts[
                                    SelectedEventOrStdResType?.idreservationtype
                                  ]?.adult
                                }
                                child={
                                  guestCounts[
                                    SelectedEventOrStdResType?.idreservationtype
                                  ]?.child
                                }
                                kid={
                                  guestCounts[
                                    SelectedEventOrStdResType?.idreservationtype
                                  ]?.kid
                                }
                                baby={
                                  guestCounts[
                                    SelectedEventOrStdResType?.idreservationtype
                                  ]?.baby
                                }
                                toddler={
                                  guestCounts[
                                    SelectedEventOrStdResType?.idreservationtype
                                  ]?.toddler
                                }
                                selectedExtraProduct={selectedExtraProduct}
                                transactionDetails={transactionDetails}
                                transactionPrice={
                                  transactionDetails?.pricePerReservation
                                }
                                excludingVat={
                                  TOTAL_INCLUSIVE_VAT -
                                  TOTAL_VAT -
                                  transactionDetails?.pricePerReservation
                                }
                                totalVat={TOTAL_VAT}
                                totalIncludingVAT={TOTAL_INCLUSIVE_VAT}
                                totalCostYourBooking={TotalPrice + totalSum}
                                GuestDetailsData={GuestDetailsData}
                                extraFieldsData={extraFieldsData}
                                setAddFields={setAddFields}
                                setGuestFields={setGuestFields}
                                combinationUpsale={selectedCombinationUpsale}
                                setCombinationUpsale={
                                  setSelectedCombinationExtraProduct
                                }
                                total_product_price={TOTAL_PRODUCT_PRICE}
                              />
                            );

                          case languageWords?.ConfirmandPay || "Confirm":
                            return <ConfirmandPay />;

                          default:
                            return <div>No page found</div>;
                        }
                      })()}
                    </Box>

                  </React.Fragment>
                )}
              </div>
           
            </Box>
          </Box>
        )}
      </Formik>
      <Box sx={{ width: 500 }}>
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={open}
          onClose={handleClosebar}
          message="Reservation creation Unsuccessful"
          key={vertical + horizontal}
        />
      </Box>
    </>
  );
}
